import ShareWrapper from '../src/LikingPhotos/ShareWrapper.tsx';
export default ShareWrapper;
